import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { Migalha } from 'models/migalha';
import { MigalhasService } from 'app/shared/migalhas/migalhas.service';
import { PosService } from '../service/pos.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from 'environments/environment';

@Component({
  selector: 'cm-detalhe-curso',
  templateUrl: './detalhe-curso.component.html',
  styleUrls: ['./detalhe-curso.component.scss'],
  animations: [routerTransition],
})
export class DetalheCursoComponent implements OnInit, OnDestroy {
  environment = environment;
  loading: boolean = true;

  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  url: BehaviorSubject<string> = new BehaviorSubject<string>('');
  routerObserver: Subscription;
  migalhasObserver: Subscription;
  cursoSelecionado: any;
  migalhas: Migalha[];
  cursoIdentificador: string;
  cursoCarregando = true;

  detalhesCurso: Object[] = [];
  detalhesCursoPos = {};

  baseMenuLateral = {
    nome: 'Pos-Graduação',
    link: '/pos-graduacao/pos-graduacao/',
  };

  baseMenuLateralMobile = {
    nome: 'Menu ',
    link: '',
  };

  menuLateral = [
    {
      nome: 'Sobre o programa',
      link: 'sobre-o-programa',

    },

  ];

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
    private posService: PosService,
    private route: ActivatedRoute
  ) {
    const migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObserver = this.migalhasService
        .iniciar([migalhaRaiz])
        .subscribe((dados) => {
          this.migalhas = dados;
        });
    this.routerObserver = this.router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe((event: NavigationEnd) => {
            this.url.next(this.router.url);
            this.migalhasService.novaUrl(this.router.url);
        });

   }

   ngOnInit() {
    this.getCursoDetalhePos()
   }

   async getCursoDetalhePos() {
    let codigoCurso: string

    this.route.params.subscribe(params => {
      const curso = params['curso']
      codigoCurso = curso
    })


    await this.posService.getCursosPosPerId(Number(codigoCurso)).then(curso => {
      this.detalhesCursoPos = curso[0]
    })


    this.loading = false;
   }



  ngOnDestroy() {
    if (this.routerObserver) {
      this.routerObserver.unsubscribe();
    }
    if (this.migalhasObserver) {
      this.migalhasObserver.unsubscribe();
    }
  }

}
